// Load curve and per-home demand. The curve is a shape with mean 1.0 over the day, so
// demand per home per day equals balance.homes.demandPerDay regardless of shape.
import type { Balance } from './types';

/** Control points (hour, relative load). Linear between points. Wraps at 24. */
const SHAPE: [number, number][] = [
  [0, 0.7],
  [4, 0.55],
  [6, 0.7],
  [8, 1.0],
  [12, 1.05],
  [16, 1.1],
  [18, 1.3],
  [19, 1.5],
  [21, 1.3],
  [23, 0.85],
  [24, 0.7],
];

function rawShape(hour: number): number {
  const h = ((hour % 24) + 24) % 24;
  for (let i = 0; i < SHAPE.length - 1; i++) {
    const a = SHAPE[i];
    const b = SHAPE[i + 1];
    if (!a || !b) continue;
    if (h >= a[0] && h <= b[0]) {
      const t = b[0] === a[0] ? 0 : (h - a[0]) / (b[0] - a[0]);
      return a[1] + (b[1] - a[1]) * t;
    }
  }
  return 1;
}

// Normalise so the mean over a day is exactly 1.0 (sampled at 1/10 hour).
const SAMPLES = 240;
let sum = 0;
for (let i = 0; i < SAMPLES; i++) sum += rawShape((i / SAMPLES) * 24);
const MEAN = sum / SAMPLES;

/** Relative load at an hour of day; mean over the day is 1.0. Peaks at 19:00. */
export function loadCurve(hour: number): number {
  return rawShape(hour) / MEAN;
}

/** Demand of one home during one tick at the given hour, in units. */
export function homeDemandPerTick(hour: number, balance: Balance): number {
  const ticksPerDay = balance.time.ticksPerHour * balance.time.hoursPerDay;
  return (balance.homes.demandPerDay / ticksPerDay) * loadCurve(hour);
}
